package com.trevorwiebe.timesheet.admin.reporting.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.unitNumberOrder
import com.trevorwiebe.timesheet.admin.reporting.domain.IftaStateTotal
import com.trevorwiebe.timesheet.admin.reporting.domain.LoadWithoutTruck
import com.trevorwiebe.timesheet.admin.reporting.domain.MissingStartEndBoundary
import com.trevorwiebe.timesheet.admin.reporting.domain.RevenuePerMileReport
import com.trevorwiebe.timesheet.admin.reporting.domain.TruckMileageTotal
import com.trevorwiebe.timesheet.core.domain.model.Customer
import com.trevorwiebe.timesheet.core.domain.model.DatabaseUserModel
import com.trevorwiebe.timesheet.loads.domain.model.Load
import com.trevorwiebe.timesheet.mileage.domain.model.Equipment
import com.trevorwiebe.timesheet.mileage.domain.model.EquipmentType
import com.trevorwiebe.timesheet.mileage.domain.model.Location
import com.trevorwiebe.timesheet.mileage.domain.model.MileageEntry
import com.trevorwiebe.timesheet.mileage.presentation.MileageFilter

data class ReportingState(
    val entries: List<MileageEntry> = emptyList(),
    val iftaRows: List<IftaStateTotal> = emptyList(),
    val generalMileageRows: List<TruckMileageTotal> = emptyList(),
    val missingStartEndRows: List<MissingStartEndBoundary> = emptyList(),
    val equipment: List<Equipment> = emptyList(),
    val userList: List<DatabaseUserModel> = emptyList(),
    val isLoading: Boolean = true,
    val error: String? = null,
    val filter: MileageFilter = MileageFilter(),
    val reportType: ReportType = ReportType.IFTA,
    val fixDialog: MissingStartEndFixState? = null,
    // Load-based reports. Their mileage entries are fetched separately, unfiltered and one day
    // past the range, because truck matching needs every driver's log around each load.
    val loads: List<Load> = emptyList(),
    val customers: List<Customer> = emptyList(),
    val locations: List<Location> = emptyList(),
    val matchEntries: List<MileageEntry> = emptyList(),
    val revenuePerMile: RevenuePerMileReport = RevenuePerMileReport(),
    val loadsWithoutTruckRows: List<LoadWithoutTruck> = emptyList(),
    val setTruckDialog: SetTruckState? = null,
    val loadsLoaded: Boolean = false,
    val matchEntriesLoaded: Boolean = false,
) {
    // Without this the load reports briefly render every truck at $0.00 before loads arrive.
    val isLoadReportLoading: Boolean
        get() = reportType.usesLoads && !(loadsLoaded && matchEntriesLoaded)

    val trucks: List<Equipment>
        get() = equipment
            .filter { it.type == EquipmentType.TRUCK && it.active && !it.deleted }
            .sortedWith(compareBy(unitNumberOrder) { it.unitNumber })
}

data class SetTruckState(
    val row: LoadWithoutTruck,
    val isSaving: Boolean = false,
    val error: String? = null,
)

data class MissingStartEndFixState(
    val boundary: MissingStartEndBoundary,
    val entriesBefore: List<MileageEntry> = emptyList(),
    val entriesAfter: List<MileageEntry> = emptyList(),
    val endTemplate: MileageEntry? = null,
    val startTemplate: MileageEntry? = null,
    val mileageText: String = "",
    val locationText: String = "",
    val isSaving: Boolean = false,
    val error: String? = null,
    val warnDifference: Long? = null,
)
